import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LanguagesService } from "@easyfo/common-lib";
import { UsersService } from "src/app/services/user";

@Component({
  selector: "app-verification-email",
  templateUrl: "./verification.html",
  styleUrls: ["./verification.css"]
})
export class EmailVerificationComponent implements OnInit {

  isInitialPage: boolean = false;
  sending: boolean = false;
  state?: { type: "info" | "error", message: string } = undefined;
  email: string = "";

  timerInterval: any;
  resendVerifyEmail: string = this._languagesService.getTextForTs("verification_app.resend_verify_email");
  sendButtonText: string = this.resendVerifyEmail;
  countdown = 0;
  constructor(
    private _userService: UsersService,
    private _router: Router,
    private _languagesService: LanguagesService
  ) {
    this._languagesService.setDefault();
  }

  ngOnInit(): void {
    this.getAndCheckUser()
  }

  async getAndCheckUser() {
    this.isInitialPage = false;
    this._userService.reloadAndGetUser().then((user) => {
      if (user.emailVerified) this._router.navigate(["/login"]);
      else if (!user.email) this._router.navigate(["/login"]);
      else this.email = user!.email!;
    })
      .catch(() => this._router.navigate(["/login"]))
      .finally(() => this.isInitialPage = true);
  }

  async resendVerificationEmail() {
    try {
      this.sending = true;
      this.sendButtonText = `${this._languagesService.getTextForTs("verification_app.sending")}...`;
      const response = await this._userService.sendVerificationEmail();
      if (this.sending) {
        this.state = { type: "info", message: this._languagesService.getTextForTs("verification_app.new_verify_sent") };
        let countdown = 60;
        this.timerInterval = setInterval(() => {
          if (countdown <= 0) {
            clearInterval(this.timerInterval);
            this.sending = false;
            this.sendButtonText = this.resendVerifyEmail;
            return;
          }
          this.sendButtonText = `${this._languagesService.getTextForTs("verification_app.try_again_in")} ${countdown}`;
          countdown--;
        }, 1000);
      } else {
        this.state = { type: "error", message: this._languagesService.getTextForTs("global.alert_message.fail.something_wrong") };
      }
    } catch (error: any) {
      this.state = { type: "error", message: this._languagesService.getTextForTs("global.alert_message.fail.something_wrong") };
      this.sendButtonText = this.resendVerifyEmail;
      this.sending = false;
      this.countdown = 0;
      clearInterval(this.timerInterval);
    }
  }

  async reloadUser() {
    this.getAndCheckUser();
  }

  signInClick() {
    this._userService.logoutFirebase();
    this._router.navigate(["/login"]);
  }
}